import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Input, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ActionList from "../components/ActionList";
import ServiceDocumentGrid from "../components/ServiceDocumentGrid";

import { useDispatch, useSelector } from "react-redux";
import * as testingEquipmentActions from "../actions/IneTestingEquipmentActions";

const IneTestingEquipmentEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, getValues, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id } = useParams();

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.equipment.loadingFBO);
    const fbo = useSelector((state) => state.equipment.fbo);
    
    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [refreshAction, setRefreshAction] = React.useState(false);

    React.useEffect(() => {
	    dispatch(testingEquipmentActions.loadTestingEquipment(id, navigate));
    }, [id]);

    React.useEffect(() => {
		setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        
        if(fbo) {
            reset(fbo.testingEquipment);
        }
        
        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onChangeDocument = (isProduct) => {
        setRefreshAction(!refreshAction);
    }

    const onTestingEquipmentChange = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "inspectionHour") {
                value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            }
        }

        if(value) {
            copy_fboState.testingEquipment[name] = value;
        }
        else if(value === false) {
            copy_fboState.testingEquipment[name] = false;
        }
        else {
            copy_fboState.testingEquipment[name] = null;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onSaveTestingEquipment = async() => {
        const valid = await trigger();
        if(valid) {
            dispatch(testingEquipmentActions.saveTestingEquipment(fboState, navigate));
        }
    }

    const onCancelTestingEquipment = () => {
        setFBOState(fbo);
        setIsDirty(false);
        clearErrors();
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={fboState && fboState.testingEquipment.id > 0 ? "Edit Equipment" : "Add Equipment"} />
                    <Row>
                        <Col lg={fboState && fboState.testingEquipment.id > 0 ? 9 : 12}>
                            <CardLoader loading={loading} />

                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Equipment</h5>
                                    <div className="flex-shrink-0">
                                        <div className="d-flex flex-wrap gap-2">
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onSaveTestingEquipment}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Save Equipment
                                            </button>
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onCancelTestingEquipment}
                                            >
                                                <i className="ri-close-line label-icon align-middle"></i> Cancel
                                            </button>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={6} md={6}>
                                            <Label className="form-label">Name<span className="required">*</span></Label>
                                            <input type="text" className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                                title={errors.name?.message}
                                                value={(fboState && fboState.testingEquipment.name) || ""}
                                                {...register("name", { required: "Name is required" })}
                                                onChange={e => onTestingEquipmentChange("name", e.target.value, false)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={3}>
                                            <Label className="form-label">Per / Hours<span className="required">*</span></Label>
                                            <input type="text" className={`form-control ${errors.inspectionHour ? "is-invalid" : ""}`}
                                                title={errors.inspectionHour?.message}
                                                value={(fboState && fboState.testingEquipment.inspectionHour) || ""}
                                                {...register("inspectionHour", { required: "Per / Hours is required" })}
                                                onChange={e => onTestingEquipmentChange("inspectionHour", e.target.value, false)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={3}>
                                            <Label className="form-label">Active</Label>
                                            <select className="form-select"
                                                value={(fboState && fboState.testingEquipment.active) || false}
                                                onChange={e => onTestingEquipmentChange("active", e.target.value == "true" ? true : false)}
                                            >
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                            </select>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        
                        {fboState && fboState.testingEquipment.id > 0 &&
                        <Col lg={3}>
                            <ActionList id={fboState.testingEquipment.id} name={"TESTING_EQUIPMENT"} refreshAction={refreshAction} />
                        </Col>
                        }
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IneTestingEquipmentEditScreen;